module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Invoice Management Component Usage Example")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "example-section new-invoice"
  }, [_c('h4', [_vm._v("🆕 NEW CC Export Invoice (paymentId = \"\") → Defaults to \"Normal\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ccExportConfig,
      "moduleDetail": _vm.ccExportDetail,
      "paymentDetail": _vm.ccExportNewPaymentDetail,
      "invoiceList": _vm.ccExportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ccExportDetail.ccImportSeries
    },
    on: {
      "add-invoice": _vm.addCCExportInvoice,
      "remove-invoice": _vm.removeCCExportInvoice,
      "remove-invoice-currency": _vm.removeCCExportInvoiceCurrency,
      "save-and-submit": _vm.saveCCExportInvoiceData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-section new-invoice"
  }, [_c('h4', [_vm._v("🆕 NEW FF Export Invoice (paymentId = \"\") → Defaults to \"Normal\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ffExportConfig,
      "moduleDetail": _vm.ffExportDetail,
      "paymentDetail": _vm.ffExportNewPaymentDetail,
      "invoiceList": _vm.ffExportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ffExportDetail.ffExportFclSeries
    },
    on: {
      "add-invoice": _vm.addFFExportInvoice,
      "remove-invoice": _vm.removeFFExportInvoice,
      "remove-invoice-currency": _vm.removeFFExportInvoiceCurrency,
      "save-and-submit": _vm.saveFFExportInvoiceData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-section existing-invoice"
  }, [_c('h4', [_vm._v("📋 EXISTING CC Export Invoice (paymentId = \"CC_PAY_001\") → Defaults to \"Supplementary\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ccExportConfig,
      "moduleDetail": _vm.ccExportDetail,
      "paymentDetail": _vm.ccExportExistingPaymentDetail,
      "invoiceList": _vm.ccExportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ccExportDetail.ccImportSeries
    },
    on: {
      "add-invoice": _vm.addCCExportInvoice,
      "remove-invoice": _vm.removeCCExportInvoice,
      "remove-invoice-currency": _vm.removeCCExportInvoiceCurrency,
      "save-and-submit": _vm.saveCCExportInvoiceData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-section existing-invoice"
  }, [_c('h4', [_vm._v("📋 EXISTING FF Export Invoice (paymentId = \"FF_PAY_001\") → Defaults to \"Supplementary\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ffExportConfig,
      "moduleDetail": _vm.ffExportDetail,
      "paymentDetail": _vm.ffExportExistingPaymentDetail,
      "invoiceList": _vm.ffExportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ffExportDetail.ffExportFclSeries
    },
    on: {
      "add-invoice": _vm.addFFExportInvoice,
      "remove-invoice": _vm.removeFFExportInvoice,
      "remove-invoice-currency": _vm.removeFFExportInvoiceCurrency,
      "save-and-submit": _vm.saveFFExportInvoiceData
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "example-section"
  }, [_c('h4', [_vm._v("CC Import - Existing Invoice (paymentId = \"CC_IMP_PAY_001\") → Defaults to \"Supplementary\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ccImportConfig,
      "moduleDetail": _vm.ccImportDetail,
      "paymentDetail": _vm.ccImportExistingPaymentDetail,
      "invoiceList": _vm.ccImportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ccImportDetail.ccImportSeries
    },
    on: {
      "add-invoice": _vm.addCCImportInvoice,
      "remove-invoice": _vm.removeCCImportInvoice,
      "remove-invoice-currency": _vm.removeCCImportInvoiceCurrency,
      "save-and-submit": _vm.saveCCImportInvoiceData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-section"
  }, [_c('h4', [_vm._v("FF Import - Existing Invoice (paymentId = \"FF_IMP_PAY_001\") → Defaults to \"Supplementary\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.ffImportConfig,
      "moduleDetail": _vm.ffImportDetail,
      "paymentDetail": _vm.ffImportExistingPaymentDetail,
      "invoiceList": _vm.ffImportInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.ffImportDetail.ffImportFclSeries
    },
    on: {
      "add-invoice": _vm.addFFImportInvoice,
      "remove-invoice": _vm.removeFFImportInvoice,
      "remove-invoice-currency": _vm.removeFFImportInvoiceCurrency,
      "save-and-submit": _vm.saveFFImportInvoiceData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "example-section"
  }, [_c('h4', [_vm._v("MISC Invoice - Existing Invoice (paymentId = \"MISC_PAY_001\") → Defaults to \"Supplementary\"")]), _vm._v(" "), _c('InvoiceManagementComponent', {
    attrs: {
      "config": _vm.miscInvoiceConfig,
      "moduleDetail": _vm.miscInvoiceDetail,
      "paymentDetail": _vm.miscInvoiceExistingPaymentDetail,
      "invoiceList": _vm.miscInvoiceList,
      "showRevisedMailCheckbox": true,
      "assignmentNumber": _vm.miscInvoiceDetail.miscSeries
    },
    on: {
      "add-invoice": _vm.addMiscInvoice,
      "remove-invoice": _vm.removeMiscInvoice,
      "remove-invoice-currency": _vm.removeMiscInvoiceCurrency,
      "save-and-submit": _vm.saveMiscInvoiceData
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-section"
  }, [_c('h3', [_vm._v("🎯 Default Radio Button Behavior Demonstration")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rule:")]), _vm._v(" New invoices (no payment ID) default to \"Normal\", Existing invoices (with payment ID) default to \"Supplementary\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-section"
  }, [_c('h3', [_vm._v("📋 Additional Module Type Examples")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f545e4d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/InvoiceManagementExample.vue
// module id = 2913
// module chunks = 0